var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"usage-terms-create"},[_c('usage-terms-form',{attrs:{"admin":_vm.isAdminUsageTerms}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }